import dolomiten from './dolomiten.png'
import zett from './zett.png'

const paperImage = {
  dolomiten: dolomiten,
  zett: zett,
}

export default paperImage
